import { render, staticRenderFns } from "./CurrentResidentCard.vue?vue&type=template&id=9ed5c35e&"
import script from "./CurrentResidentCard.vue?vue&type=script&lang=js&"
export * from "./CurrentResidentCard.vue?vue&type=script&lang=js&"
import style0 from "./CurrentResidentCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports